import ReactDOMServer from 'react-dom/server';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { MDSIcon } from '@marqvision/mds-v2';

const icons = ReactQuill.Quill.import('ui/icons');
icons['bold'] = ReactDOMServer.renderToString(<MDSIcon.Bold size={20} />);
icons['italic'] = ReactDOMServer.renderToString(<MDSIcon.Italic size={20} />);
icons['underline'] = ReactDOMServer.renderToString(<MDSIcon.Underline size={20} />);
icons['list']['ordered'] = ReactDOMServer.renderToString(<MDSIcon.ListNumbered size={20} />);
icons['list']['bullet'] = ReactDOMServer.renderToString(<MDSIcon.ListBulleted size={20} />);
icons['link'] = ReactDOMServer.renderToString(<MDSIcon.LinkUrl size={20} />);
icons['image'] = ReactDOMServer.renderToString(<MDSIcon.Image variant="outline" size={20} />);
